import React, { memo } from "react";

const TreatmentsCard = memo((props) => {
  const { showFullText = false, Image, title, description, subtitle, time, cost } = props;
  
  return (
    <div className="flex w-[390px] flex-col md:flex-row  md:h-[430px] h-[650px] md:w-[630px] bg-primary m-1 lg:m-1 md:relative rounded-tl-3xl rounded-br-3xl">
      <div className="md:w-[51%] w-[80%] flex items-center justify-center m-auto md:p-0 md:h-[85%] h-[50%] overflow-hidden rounded-tl-3xl rounded-br-3xl">
        <img
          src={Image}
          className="w-full h-full object-cover rounded-tl-3xl rounded-br-3xl"
          alt={title}
          loading="lazy"
        />
      </div>
      
      <div className="md:w-[49%] w-full md:h-full h-[50%] p-2 md:p-3 flex flex-col relative">
        <h3 className="font-medium md:text-lg md:absolute md:top-2 left-4 leading-tight ">
           {title}
        </h3>
        
        <div className={`md:absolute ${showFullText ? 'md:top-8' : 'md:top-12'} top-8 pr-2 flex-1 overflow-hidden`}>
          <div className="text-sm p-2 whitespace-pre-line leading-relaxed">
            {showFullText ? (
              <span>
                {description}
              </span>
            ) : (
              <span className="line-clamp-4 md:line-clamp-3">
                {description}
              </span>
            )}
          </div>
          
          {subtitle && subtitle.length > 0 && (
            <ul className="md:text-sm text-xs px-2 space-y-1">
              {subtitle.map((item, index) => (
                <li key={index} className="line-clamp-1">
                  - {item}
                </li>
              ))}
            </ul>
          )}
        </div>

        {time && time.length > 0 && cost && cost !== "$0" && cost !== "$00" && cost !== "$" && (
          <div className="absolute md:bottom-4 bottom-2 md:left-4 left-4 right-4 flex justify-between items-center">
            <a
              href="https://www.fresha.com/book-now/sepiyar-aesthetics-fl1if9ef/all-offer?id=1296763&pId=1231093"
              target="_blank"
              rel="noopener noreferrer"
              className=" md:w-[120px] w-[100px] text-sm duration-300 hover:text-white bg-[#A18168] border-[#A18168] border text-white  px-1 py-1 rounded-2xl shadow-2xl text-center"
            >
              Book Now
            </a>
            <div className="md:text-sm text-xs font-semibold bg-white/80 px-2 py-1 rounded-2xl text-gray-800">
              {time} | {cost}
            </div>
          </div>
        )}
        
        {(!time || time.length === 0 || !cost || cost === "$0" || cost === "$00" || cost === "$") && (
          <div className="absolute md:bottom-4 bottom-2 md:left-4 left-4 right-4">
            <div className="flex flex-wrap gap-2">
              <a
                href="https://www.fresha.com/book-now/sepiyar-aesthetics-fl1if9ef/all-offer?id=1296763&pId=1231093"
                target="_blank" 
                rel="noopener noreferrer"
                className=" md:w-[120px] w-[100px] md:text-sm text-xs duration-300 hover:text-white bg-[#A18168] border-[#A18168] border text-white px-1 py-1 rounded-2xl shadow-2xl text-center"
              >
                Book Now
              </a>
              <a 
                href="/Treatments"
                className="hover:bg-black hover:-translate-y-1 md:w-[120px] w-[100px] md:text-sm text-xs duration-300 hover:text-white bg-[#A18168] border-[#A18168] border text-white px-4 py-1 rounded-2xl shadow-2xl text-center"
              >
                Read more
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

TreatmentsCard.displayName = 'TreatmentsCard';

export default TreatmentsCard;
